import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import PatientList from "./components/PatientList";
import { setIsEdit } from "../../../redux/slices/PageSlice";
import SearchBox from "./components/Searchbox";
import Api from "../../../core/Api";
import {
  clearGroup,
  setAllDataSelected,
  setAnemnez,
  setCurrentStep,
  setSelectedUser,
  setSelectItem,
} from "../../../redux/slices/searchSlice";
import { emptyDescription } from "../../../redux/slices/fileUploadSlice";
import Loading from "../../../components/Loading";

const SelectPatient = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const resp = await Api.getAllAnimalOwnersAsync();
      setData(resp.data.data);
    };
    fetchData();
  }, []);

  const navigate = useNavigate();

  const onClickHandle = () => {
    setLoading(true);
    dispatch(setIsEdit(false));
    dispatch(setCurrentStep(1));
    dispatch(setSelectItem(null));
    dispatch(setSelectedUser(null));
    dispatch(emptyDescription());
    dispatch(clearGroup());
    dispatch(setAllDataSelected({}));
    setLoading(false);
    navigate("/select-patient/request-form");
  };

  return (
    <div className="select-patient  animate__animated animate__fadeIn">
      {loading ? (
        <Loading />
      ) : (
        <div className="pt-4">
          <div className="flex  justify-center font-bold text-3xl drop-shadow-md">
            Hasta Seç
          </div>
          <div className="mt-8 gap-2">
            <div className="px-2">
              <SearchBox data={data} />
              <PatientList onClickHandle={onClickHandle} />
              <div
                onClick={() => onClickHandle()}
                className="flex justify-center"
              >
                <Link to="">
                  <button
                    onClick={() => onClickHandle()}
                    className="mr-2 mt-8 mb-8 p-2 text-base w-48 border bg-[#4a50a2] text-white rounded-lg font-semibold hover:bg-[#34398b] flex flex-col duration-100 gap-4 items-center "
                  >
                    Yeni Kayıt Oluştur
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectPatient;
